import { FiStar } from 'react-icons/fi';
import { useState } from 'react';

export default function Estrellas({ valor = 0, onCambio, soloLectura = false, tamano = 22 }) {
    const [hover, setHover] = useState(0);
    const valorActivo = hover || valor;

    return (
        <div className={`estrellas ${soloLectura ? 'estrellas-readonly' : ''}`}>
            {[1, 2, 3, 4, 5].map(n => (
                <span
                    key={n}
                    className={`star ${n <= valorActivo ? 'llena' : ''}`}
                    onClick={() => !soloLectura && onCambio && onCambio(n)}
                    onMouseEnter={() => !soloLectura && setHover(n)}
                    onMouseLeave={() => !soloLectura && setHover(0)}
                    style={{ fontSize: tamano }}
                >
                    <FiStar fill={n <= valorActivo ? 'currentColor' : 'none'} />
                </span>
            ))}
        </div>
    );
}
